import React, { useState } from "react";
import CollageTable from '../../Pages/Collegemianpage/CollageTable'
import Popupform from '../Popupform/Popupform';
import { NavLink } from "react-router-dom";
import Boucherpopup from "../Popupform/Boucherpopup";


const Innerpage = () => {

    const [showPopup, setShowPopup] = useState(false);

    const handleOpenPopup = () => {
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };



    // download boucher 
    const [showBoucherPopup, setShowBoucherPopup] = useState(false);

    const handleOpenBoucherPopup = () => setShowBoucherPopup(true);
    const handleCloseBoucherPopup = () => setShowBoucherPopup(false);

    return (
        <div>


            <div className="container-fluid">
                <div className="row">
                    <div className="col p-0 m-0">
                        <div className='background_banner'>
                            <h2>Jawaharlal Nehru University - [JNU], New Delhi</h2>
                            <p>At Get Fast Education, we are committed to guiding students toward academic success and career excellence. <br /> With expert educators and personalized support, we help you unlock a world of opportunities.</p>
                        </div>
                    </div>
                </div>
            </div>


            <div className="container">
                <div className="row m-auto">
                    <div className='text-center'>
                        <h4 className='mt-5'>Are You Interested in this College?</h4>

                        <div className='mt-4'>
                            {/* Buttons to Open the Popup */}
                            <button onClick={handleOpenPopup} className="mybtn rounded-pill mx-2">
                                Apply Now
                            </button>
                            <NavLink className="nav-link" style={{ color: '#ff7900' }} onClick={handleOpenBoucherPopup}> Download Boucher</NavLink>

                        </div>

                        {/* Popup Form */}
                        {showPopup && (
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        <div className="popup-overlay">
                                            <div className="popup-content">
                                                <button className="close-btn" onClick={handleClosePopup}>
                                                    &times;
                                                </button>
                                                <Popupform />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}



                        {/* Boucher Popup */}
                        {showBoucherPopup && (
                            <div className="popup-overlay">
                                <div className="popup-content">
                                    <button className="close-btn" onClick={handleCloseBoucherPopup}>
                                        &times;
                                    </button>
                                    <Boucherpopup />
                                    {/* <h4>Download Boucher</h4>
                                <a href="/path-to-boucher.pdf" download className="btn btn-primary mt-3">
                                    Click to Download
                                </a> */}
                                </div>
                            </div>
                        )}

                    </div>
                </div>
                <div className="row">
                    <div className="">
                        <CollageTable />
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Innerpage
